import { DateTime } from 'luxon'
import i18n from '@/i18n'

export function formatIsoDateTime (dateTimeString, format, emptyValue = '-', timeZone = null, locale = null) {
  const params = {}
  if (timeZone) {
    params.zone = timeZone
  }
  if (locale) {
    params.locale = locale
  }

  if (dateTimeString) {
    try {
      const dateTime = DateTime.fromISO(dateTimeString, params)

      if (!dateTime.isValid) {
        return '-Invalid Datetime-'
      }

      return dateTime.toFormat(format)
    } catch (e) {
      console.error('== formatIsoDateTime ==>', e)
      return 'Error parse DateTime'
    }
  }

  return emptyValue
}

/** Сегодняшняя дата (yyyy-MM-dd) в часовом поясе филиала; пояса нет или он не распознан — день браузера */
export function todayInTimeZone (timeZone = null) {
  const now = timeZone ? DateTime.now().setZone(timeZone) : DateTime.now()

  return (now.isValid ? now : DateTime.now()).toFormat('yyyy-MM-dd')
}

export function formatIsoDateTimeAsTime (dateTimeString, emptyValue = '--:--', timeZone = null) {
  return formatIsoDateTime(dateTimeString, 'HH:mm', emptyValue, timeZone)
}

export function formatIsoDateTimeAsShortYearDate (dateTimeString, emptyValue = '--.--.--', timeZone = null) {
  return formatIsoDateTime(dateTimeString, 'dd.LL.yy', emptyValue, timeZone)
}

export function formatIsoDateTimeAsDate (dateTimeString, emptyValue = '--.--.--', timeZone = null) {
  return formatIsoDateTime(dateTimeString, 'dd.LL.yyyy', emptyValue, timeZone)
}

export function formatIsoDateTimeAsDateTime (dateTimeString, emptyValue = '----', timeZone = null) {
  return formatIsoDateTime(dateTimeString, 'dd.LL.yyyy HH:mm', emptyValue, timeZone)
}

export function formatIsoDateTimeAsRelativeDateTime (dateTimeString, emptyValue = '--.--.-- --:--', timeZone = null) {
  if (!dateTimeString) {
    return emptyValue
  }

  const params = timeZone ? { zone: timeZone } : {}
  const dateTime = DateTime.fromISO(dateTimeString, params)

  if (!dateTime.isValid) {
    return emptyValue
  }

  const daysFromToday = dateTime
    .startOf('day')
    .diff(DateTime.now().setZone(dateTime.zone).startOf('day'), 'days').days

  const time = dateTime.toFormat('HH:mm')

  if (daysFromToday === 0) {
    return `Сегодня в ${time}`
  }

  if (daysFromToday === -1) {
    return `Вчера в ${time}`
  }

  return dateTime.toFormat('dd.LL.yyyy HH:mm')
}

export function formatIsoDateTimeAsRelativeDate (dateTimeString, emptyValue = '--.--.--', timeZone = null) {
  if (!dateTimeString) {
    return emptyValue
  }

  const params = timeZone ? { zone: timeZone } : {}
  const dateTime = DateTime.fromISO(dateTimeString, params)

  if (!dateTime.isValid) {
    return emptyValue
  }

  const daysFromToday = dateTime
    .startOf('day')
    .diff(DateTime.now().setZone(dateTime.zone).startOf('day'), 'days').days

  if (daysFromToday === 0) {
    return 'Сегодня'
  }

  if (daysFromToday === -1) {
    return 'Вчера'
  }

  return dateTime.toFormat('dd.LL.yyyy')
}

// const createdAt = DateTime.fromFormat(this.order.createdAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
// const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
// return Duration.fromMillis(deadLine - createdAt).toFormat('mm') + ' мин'

export function secondsToHmsObject (secs) {
  const secNum = parseInt(secs, 10)
  return {
    hours: Math.floor(secNum / 3600),
    minutes: Math.floor(secNum / 60) % 60,
    seconds: secNum % 60,
  }
}

export function formatIsoDateToCurrentLocaleString (date) {
  return new Date(date).toLocaleString(i18n.locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export function secToCeilMin (sec) {
  return Math.ceil(sec / 60)
}

/*
* var toHHMMSS = (secs) => {
    var sec_num = parseInt(secs, 10)
    var hours   = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours,minutes,seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v,i) => v !== "00" || i > 0)
        .join(":")
}
* */
